import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GridService {
  createGrid(properties: GridProperties): Grid {
    return new Grid(properties);
  }
}

export class Grid {
  properties: GridProperties;
  cells: Cell[] = [];
  i: number;

  constructor(properties: GridProperties) {
    this.createCells(properties);
  }

  private createCells(properties: GridProperties) {
    this.properties = properties;

    for (let y = 0, i = 0; y < properties.rows; y++) {
      for (let x = 0; x < properties.columns; x++) {
        this.i = i;

        if (this.i < properties.totalElements) {
          this.cells.push(this.createCell(x, y, this.i, properties.columns, properties.rows));

          if (!properties.square) {
            this.moveRows(y, this.i, properties);
          }

          i = this.i;
        }

        i++;
      }
    }
  }

  private moveRows(y: number, i: number, properties: GridProperties) {
    if (properties.moveOddRows) {
      if (y % 2 == 0) {
        this.moveCell(this.cells[i], properties);
      }
    } else {
      if (y % 2 != 0) {
        this.moveCell(this.cells[i], properties);
      }
    }
  }

  private moveCell(cell: Cell, properties: GridProperties) {
    cell.metrics.positionX += cell.metrics.width / 2;
    if (cell.x == properties.columns - 1) {
      this.cells.splice(cell.index, 1);
      this.i--;
    }
  }

  private createCell(x: number, y: number, i: number, h: number, v: number) {
    let newCell: Cell = new Cell(x, y, i, this.calculateCellMetrics(x, y, h, v));
    return newCell;
  }

  private calculateCellMetrics(x: number, y: number, horElements: number, verElements: number): CellMetrics {
    let width: number = 100 / horElements;
    let height: number = 100 / verElements;
    let posX: number = width * x;
    let posY: number = height * y;
    return new CellMetrics(width, height, posX, posY);
  }
}

export class GridProperties {
  totalElements: number;
  columns: number;
  rows: number;
  moveOddRows: boolean;
  square: boolean;
  maxHorizontalElements: number;
  maxElementsInEvenRows?: boolean;

  constructor({
    totalElements: totalElements,
    square: square,
    maxHorizontalElements: maxHorizontalElements,
    maxElementsInEvenRows: maxElementsInEvenRows = false,
  }) {
    this.totalElements = totalElements;
    this.square = square;
    this.maxHorizontalElements = maxHorizontalElements;
    this.maxElementsInEvenRows = maxElementsInEvenRows;

    if (maxHorizontalElements < totalElements) {
      this.rows = Math.ceil(totalElements / maxHorizontalElements);
      this.columns = maxHorizontalElements;

      if (this.columns == 1 || this.rows == 1) {
        this.moveOddRows = false;
      } else {
        if (!square) {
          if (maxElementsInEvenRows) {
            this.moveOddRows = true;
          } else {
            this.moveOddRows = false;
          }
        } else {
          this.moveOddRows = false;
        }
      }
    } else {
      this.rows = 1;
      this.columns = totalElements;
      this.moveOddRows = false;
    }
  }
}

export class Cell {
  x: number;
  y: number;
  index: number;
  metrics: CellMetrics;

  constructor(x: number, y: number, index: number, metrics: CellMetrics) {
    this.x = x;
    this.y = y;
    this.index = index;
    this.metrics = metrics;
  }
}

export class CellMetrics {
  width: number;
  height: number;
  positionX: number;
  positionY: number;

  constructor(width: number, height: number, positionX: number, positionY: number) {
    this.width = width;
    this.height = height;
    this.positionX = positionX;
    this.positionY = positionY;
  }
}
